import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    DirectionType
} from "../../../../types/locale";
import type {
    SidebarSide
} from "../../type";
import {
    webStyle
} from "../../../../utils";

export const getSidebarRailCursor = ({
    isCollapsed,
    direction,
    side
}: {
    direction: DirectionType;
    isCollapsed: boolean;
    side: SidebarSide;
}): "w-resize" | "e-resize" => {
    const isStartward = side === "left" ? !isCollapsed : isCollapsed;

    return isStartward !== (direction === "rtl") ? "w-resize" : "e-resize";
};

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        position: "absolute",
        bottom: 0,
        top: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    line: {
        height: "100%"
    }
});

export const useStyles = ({
    shapeConfigs,
    touchTargets,
    isCollapsed,
    direction,
    isPressed,
    isActive,
    borders,
    colors,
    side
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    touchTargets: NCoreUIKit.TouchTargets;
    borders: NCoreUIKit.Borders;
    direction: DirectionType;
    isCollapsed: boolean;
    isPressed: boolean;
    isActive: boolean;
    side: SidebarSide;
}) => {
    const styles = {
        line: {
            backgroundColor: isPressed ? colors.content.border.emphasized : isActive ? colors.content.border.hover : "transparent",
            width: borders.focus
        },
        container: {
            zIndex: shapeConfigs.layers.raised + 1,
            width: touchTargets.fine
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.container, side === "left" ? {
        end: -touchTargets.fine / 2
    } : {
        start: -touchTargets.fine / 2
    }, webStyle({
        cursor: getSidebarRailCursor({
            isCollapsed,
            direction,
            side
        })
    }));

    return styles;
};
export default stylesheet;
